interface Props {
  className?: string;
}

export const CloseButtonIcon = ({ className }: Props) => {
  return (
    <svg
      width="29px"
      height="29px"
      viewBox="0 0 29 29"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          x="-1.8%"
          y="-6.2%"
          width="103.5%"
          height="112.5%"
          filterUnits="objectBoundingBox"
          id="filter-1"
        >
          <feOffset
            dx="0"
            dy="0"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="2"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0.408065575   0 0 0 0 0.408065575   0 0 0 0 0.408065575  0 0 0 0.5 0"
            type="matrix"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          ></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
      </defs>
      <g
        id="02.media"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="記事ページ" transform="translate(-337.000000, -621.000000)">
          <g
            id="Group-28"
            filter="url(#filter-1)"
            transform="translate(20.000000, 625.000000)"
          >
            <g id="Group-27" transform="translate(321.000000, 0.000000)">
              <circle
                id="Oval"
                fill="#FFFFFF"
                cx="10.5"
                cy="10.5"
                r="10.5"
              ></circle>
              <g
                id="Cross"
                transform="translate(7.000000, 8.000000)"
                stroke="#3C424A"
                strokeLinecap="round"
                strokeWidth="1.5"
              >
                <line x1="0.5" y1="6" x2="6.5" y2="0" id="Path"></line>
                <line x1="0.5" y1="0" x2="6.5" y2="6" id="Path"></line>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
